import { render, staticRenderFns } from "./StatsFooter.vue?vue&type=template&id=13b14d77&scoped=true&"
import script from "./StatsFooter.vue?vue&type=script&lang=ts&"
export * from "./StatsFooter.vue?vue&type=script&lang=ts&"
import style0 from "./StatsFooter.vue?vue&type=style&index=0&id=13b14d77&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b14d77",
  null
  
)

export default component.exports